import { render, staticRenderFns } from "./MediaCard.vue?vue&type=template&id=5d2ba034&scoped=true"
import script from "./MediaCard.vue?vue&type=script&lang=js"
export * from "./MediaCard.vue?vue&type=script&lang=js"
import style0 from "./MediaCard.vue?vue&type=style&index=0&id=5d2ba034&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2ba034",
  null
  
)

export default component.exports